export enum DeliveryDocumentTypeEnum {
  SpedLabel = 'spedLabel',
  Protocol = 'protocol',
}
